export const EXPORT_IN_PROGRESS_STATUSES = ['pending', 'started', 'scheduled']

export const EXPORT_TIMEOUT_MS = 60 * 60 * 1000

/** Matches ISO-8601 date-time strings (API *_iso fields); rejects d/m/Y display values. */
const EXPORT_JOB_ISO_TIMESTAMP_RE = /^\d{4}-\d{2}-\d{2}T/

export function getExportJobReferenceTime(row) {
    if (!row) {
        return null
    }
    return row.started_at_iso || row.created_at_iso || null
}

export function parseExportJobTimestamp(value) {
    if (value == null || value === '') {
        return null
    }
    const str = String(value)
    if (!EXPORT_JOB_ISO_TIMESTAMP_RE.test(str)) {
        return null
    }
    const time = new Date(str).getTime()
    return Number.isFinite(time) ? time : null
}

export function isExportJobInProgress(row) {
    return Boolean(
        row && EXPORT_IN_PROGRESS_STATUSES.includes(row.status)
    )
}

export function isExportJobTimedOut(row, now = Date.now()) {
    if (!isExportJobInProgress(row)) {
        return false
    }
    const refTime = parseExportJobTimestamp(getExportJobReferenceTime(row))
    if (refTime == null) {
        return false
    }
    return now - refTime >= EXPORT_TIMEOUT_MS
}

export function isExportJobPollingCandidate(row, now = Date.now()) {
    return isExportJobInProgress(row) && !isExportJobTimedOut(row, now)
}

export function buildExportJobTimeoutPatch(row, now = Date.now()) {
    if (!isExportJobTimedOut(row, now)) {
        return null
    }
    return {
        id: row.id,
        status: 'failed',
        failureReason: 'timeout',
    }
}

export function buildExportJobTimeoutPatches(rows, now = Date.now()) {
    if (!Array.isArray(rows)) {
        return []
    }
    return rows
        .map((row) => buildExportJobTimeoutPatch(row, now))
        .filter(Boolean)
}
